import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ark-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
})
export class BadgeComponent implements OnInit {
  @Input() label!: string;

  bgClasses!: string;

  @Input() icon!: string;
  @Input() iconColor!: string;
  @Input() iconSize!: string;

  @Input() preset:
    | 'wellbeing'
    | 'integrity'
    | 'social'
    | 'economic'
    | 'environmental' = 'environmental';
  constructor() {}

  ngOnInit() {
    if (this.preset) {
      this.iconColor = 'light';
      this.iconSize = 'small';
      this.icon = `value-category-${this.preset}-icon`;
      this.bgClasses = `text-xs font-bold uppercase bg-value-${this.preset}`;

      this.label = this.preset;
    }
  }
}
